import React, { useState, useEffect, useReducer } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import StepsProgressBar from "../../components/common/StepsProgressBar/StepsProgressBar";
import MultiStepForm from "../../components/MultiStepForm/MultiStepForm";

// Scss imports
import css from "./BasicAccount.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { updateMe } from "../../redux/actions/updateMeAction";
import { getCurrentUserData } from "../../redux/actions/currentUserActions";

interface BasicAccountProps {}

const BasicAccount: React.FC<BasicAccountProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  /* **** Defining states **** */
  // Defining state for current step
  const [currentStep, setCurrentStep] = useState(1);

  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(false);

  // Defining state for storing value is button clicked or not
  const [clickedLegalButton, setClickedLegalButton] = useState(false);
  const [clickedIndividualButton, setClickedIndividualButton] = useState(false);

  // State for account type
  const [accountType, setAccountType] = useState("");

  // Setting up state for all entities
  const [entity, setEntity] = useState("");

  // Setting up state for error paragraph
  const [error, setError] = useState(false);

  // Setting up state for individual entities and legal entities, using use reducer hook
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      firstName: "",
      lastName: "",
      nationalId: "",
      identificationNumber: "",
      taxId: "",
      identificationNumberE: "",
      taxIdE: "",
      businessName: "",
      place: "",
      street: "",
      buildingNumber: "",
      letter: "",
      floor: "",
      apartmentNumber: "",
      municipality: "",
      zipCode: "",
      email: "",
      phone: ""
    }
  );

  // Defining state using use state and use reducer
  /*const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [businessName, setBusinessName] = useState("");*/

  // Setting up state for holding state of active steps
  const [activeStep, setActiveStep] = useState(1);

  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "" ||
        //obj[propName] === 0 ||
        obj[propName] === null ||
        obj[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  // Function for handling submit form for setting basic account
  const handleSubmit = () => {
    dispatch(
      updateMe(
        clean({
          firstName: userInput.firstName,
          lastName: userInput.lastName,
          contactEmail: userInput.email,
          nationalId: userInput.nationalId,
          identificationNumber: userInput.identificationNumber,
          taxId: userInput.taxId,
          identificationNumberE: userInput.identificationNumberE,
          taxIdE: userInput.taxIdE,
          place: userInput.place,
          street: userInput.street,
          buildingNumber: userInput.buildingNumber,
          letter: userInput.letter,
          floor: userInput.floor,
          apartmentNumber: userInput.apartmentNumber,
          municipality: userInput.municipality,
          zipCode: userInput.zipCode,
          phone: userInput.phone,
          businessName: userInput.businessName
        }),
        history
      )
    );
  };

  // Function for setting up account type to legal entity
  const setAccountTypeToLegalEntity = () => {
    setAccountType("legal");
    setClickedIndividualButton(false);
    setClickedLegalButton(true);
    setDisabledButton(false);
  };

  // Function for setting up account type to individual
  const setAccountTypeToIndividual = () => {
    setAccountType("individual");
    setClickedLegalButton(false);
    setClickedIndividualButton(true);
    setDisabledButton(false);
  };

  // Function for setting up active classes for progress bar deepends on current step
  /*const progressBarStatusHandler = () => {
    switch (currentStep) {
      case 1:
        return setActiveStep(1);
      case 2:
        return setActiveStep(2);
      case 3:
        return setActiveStep(3);
      case 4:
        return setActiveStep(4);
      case 5:
        return setActiveStep(5);
    }
  };*/

  const progressBarStatusHandler = () => {
    if (currentStep === 1) {
      return setActiveStep(1);
    } else if (currentStep === 2 && accountType.length > 0) {
      return setActiveStep(2);
    } else if (currentStep === 3) {
      return setActiveStep(3);
    } else if (currentStep === 4) {
      return setActiveStep(4);
    } else if (currentStep === 5) {
      return setActiveStep(5);
    }
  };

  // Set next, prev buttons to disabled if certain condition is not fullfilled
  const disabledButtons = () => {
    return true;
  };

  useEffect(() => {
    dispatch(getCurrentUserData());
  }, []);

  // When we change currentStep, render progressBarStatusHandler function
  useEffect(() => {
    progressBarStatusHandler();
    disabledButtons();

    if (
      userInput.firstName.length > 0 &&
      userInput.lastName.length > 0 &&
      userInput.nationalId.length > 0 &&
      (userInput.identificationNumberE.length === 0 ||
        userInput.identificationNumberE.length === 8) &&
      (userInput.taxIdE.length === 0 || userInput.taxIdE.length === 9)
    ) {
      setDisabledButton(false);
    }

    if (currentStep === 2) {
      if (
        userInput.businessName.length > 0 &&
        userInput.identificationNumber.length === 8 &&
        userInput.taxId.length === 9
      ) {
        setDisabledButton(false);
      }
    }

    if (currentStep === 3) {
      if (
        userInput.place.length > 0 &&
        userInput.street.length > 0 &&
        userInput.municipality.length > 0 &&
        userInput.zipCode > 0
      ) {
        setDisabledButton(false);
      }
    }

    if (currentStep === 4) {
      if (
        userInput.businessName.phone > 0 &&
        userInput.businessName.email > 0
      ) {
        setDisabledButton(false);
      }
    }
    /*if (
      userInput.place.length > 0 &&
      userInput.street.length > 0 &&
      userInput.muncipality.length > 0 &&
      userInput.place.zipCode > 0 &&
      userInput.buildingNumber.length > 0
    ) {
      setDisabledButton(false);
    }*/
  });

  // Function for toogling disabled button and not disabled button
  const isButtonDisabled = () => {
    return false;
  };

  const handleChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  // Handling click on progress bar
  const onStepClickHandler = (e: any) => {
    if (currentStep === 1 && accountType.length > 0) {
      setCurrentStep(e);
    } else if (
      (currentStep === 2 &&
        accountType === "individual" &&
        userInput.firstName.length > 0 &&
        userInput.lastName.length &&
        userInput.nationalId.length > 0) ||
      (currentStep === 2 && accountType === "legal")
    ) {
      setCurrentStep(e);
    } else if (
      currentStep === 3 &&
      userInput.place.length > 0 &&
      userInput.street.length > 0 &&
      userInput.municipality.length > 0 &&
      userInput.zipCode > 0 &&
      userInput.buildingNumber.length > 0
    ) {
      setCurrentStep(e);
    } else if (
      currentStep === 4 &&
      userInput.place.phone > 0 &&
      userInput.street.email > 0
    ) {
      setCurrentStep(e);
    }
  };

  // On next button click
  const nextButtonClickHandler = () => {
    if (currentStep === 1) {
      if (clickedLegalButton || clickedIndividualButton) {
        setError(false);
        setCurrentStep(2);
      } else {
        setError(true);
        setDisabledButton(true);
      }
    }
    if (currentStep === 2 && accountType === "individual") {
      if (
        userInput.firstName === "" ||
        userInput.lastName === "" ||
        userInput.nationalId === "" ||
        (userInput.identificationNumberE.length > 0 &&
          userInput.identificationNumberE.length !== 8) ||
        (userInput.taxIdE.length > 0 && userInput.taxIdE.length !== 9)
      ) {
        setError(true);
        setDisabledButton(true);
      } else return setCurrentStep(3);
    }
    if (currentStep === 2 && accountType === "legal") {
      if (
        userInput.businessName === "" ||
        userInput.identificationNumber.length !== 8 ||
        userInput.taxId.length !== 9
      ) {
        setError(true);
        setDisabledButton(true);
      } else return setCurrentStep(3);
    }
    /*if (currentStep === 3) {
      if (
        userInput.place === "" ||
        userInput.street === "" ||
        userInput.muncipality === "" ||
        userInput.zipCode === "" ||
        userInput.buildingNumber === ""
      ) {
        setError(true);
        setDisabledButton(true);
      } else return setCurrentStep(4);
    }*/
    if (currentStep === 3) {
      if (
        userInput.place === "" ||
        userInput.street === "" ||
        userInput.municipality === "" ||
        userInput.zipCode === ""
      ) {
        setError(true);
        setDisabledButton(true);
      } else return setCurrentStep(4);
    }

    if (currentStep === 4) {
      if (userInput.phone === "" || userInput.email === "") {
        setError(true);
        setDisabledButton(true);
      } else return setCurrentStep(5);
    }
  };

  return (
    <div className={css.container}>
      <div className={css.selectAccountContainer}>
        <h2>Изаберите кориснички налог</h2>
        <StepsProgressBar
          activeStep={activeStep}
          onStepClickHandler={onStepClickHandler}
        />
        {/* Multi step form */}
        <MultiStepForm
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          accountType={accountType}
          setAccountTypeToIndividual={() => {
            setAccountTypeToIndividual();
          }}
          setAccountTypeToLegalEntity={() => setAccountTypeToLegalEntity()}
          handleSubmit={() => handleSubmit()}
          isButtonDisabled={isButtonDisabled()}
          buttonLegalClicked={clickedLegalButton}
          buttonIndividualClicked={clickedIndividualButton}
          firstName={userInput.firstName}
          lastName={userInput.lastName}
          nationalId={userInput.nationalId}
          identificationNumber={userInput.identificationNumber}
          taxId={userInput.taxId}
          identificationNumberE={userInput.identificationNumberE}
          taxIdE={userInput.taxIdE}
          handleChange={handleChange}
          businessName={userInput.businessName}
          place={userInput.place}
          street={userInput.street}
          buildingNumber={userInput.buildingNumber}
          letter={userInput.letter}
          floor={userInput.floor}
          apartmentNumber={userInput.apartmentNumber}
          municipality={userInput.municipality}
          zipCode={userInput.zipCode}
          email={userInput.email}
          phone={userInput.phone}
          nextButtonClickHandler={nextButtonClickHandler}
          disabledButton={disabledButton}
          error={error}
        />
      </div>
    </div>
  );
};

export default BasicAccount;
